<template>
  <div>
    <div class="accordion-trigger" @click="show = !show">
      <slot name="trigger" />

      <svg class="accordion-angle" :class="{'active': show}" width="12px" height="12px" fill="grey">
        <use xlink:href="@/assets/images/sprite.svg#angle"></use>
      </svg>
    </div>

    <template v-if="show">
      <slot name="default" />
    </template>
  </div>
</template>

<script>
export default {
  name: "accordion-list",
  data() {
    return {
      show: true,
    };
  },
};
</script>

<style scoped>
.accordion-trigger {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.accordion-angle {
  transform: rotate(-90deg);
  transition: all 0.2s;
}

.accordion-angle.active {
  transform: rotate(90deg);
}
</style>